// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__32_Tt","requiredAsterisk":"Info_requiredAsterisk__1AiaO"};